import React from 'react';
import { useNavigate, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getBookingIntent, clearBookingIntent } from '../../utils/bookingIntent';
import { areasForRoles, currentAreaFromPath } from '../../utils/areaOptions';
import './ScegliAreaPage.css';

const ScegliAreaPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getRoles, isAuthenticated } = useAuth();
  const roles = getRoles();
  const current = currentAreaFromPath(location.state?.fromPath || '');

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const availableOptions = areasForRoles(roles);

  if (availableOptions.length === 0) {
    return <Navigate to="/login" replace />;
  }

  if (availableOptions.length === 1) {
    return <Navigate to={availableOptions[0].path} replace />;
  }

  const goTo = (opt) => {
    if (opt.role === 'PAZIENTE') {
      const intent = getBookingIntent();
      if (intent?.path) {
        clearBookingIntent();
        navigate(intent.path, { replace: true, state: intent.state || {} });
        return;
      }
    }
    navigate(opt.path, { replace: true });
  };

  return (
    <div className="scegli-area-page">
      <div className="scegli-area-card">
        <h1 className="scegli-area-title">Scegli in quale area entrare</h1>
        <p className="scegli-area-subtitle">
          Hai accesso a più aree con lo stesso account. Puoi cambiare area in qualsiasi
          momento dall&apos;intestazione, senza fare logout.
        </p>
        <div className="scegli-area-buttons">
          {availableOptions.map((opt) => {
            const isCurrent = current?.role === opt.role;
            return (
              <button
                key={opt.role}
                type="button"
                className={`scegli-area-btn${isCurrent ? ' is-current' : ''}`}
                onClick={() => goTo(opt)}
              >
                <span className="scegli-area-btn-label">
                  {opt.label}
                  {isCurrent ? ' · attuale' : ''}
                </span>
                <span className="scegli-area-btn-desc">{opt.description}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ScegliAreaPage;
